module.exports = __webpack_public_path__ + "img/03.e01fbce9.png";